<template>
  <div>
    <div
      v-if="loading === true"
      class="spinner-grow text-primary"
      style="margin-top: 15%;margin-left: 45%;"
    />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2 mr-1"
          @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2"
          data-toggle="modal"
          data-target="#createModal"
        >
          Create
        </button>
        <create
          v-if="$router.currentRoute.name === 'invoice-payments'"
          @refresh="renderTable()"
        />
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :actions-obj="actionsArray"
      @choosenObject="getEditedObject($event)"
      @dynamicAction="handleActions($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
       v-if="$router.currentRoute.name === 'invoice-payments'"
       :payment="editedPayment"
       @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import paymentService from '@/services/paymentService'

export default {
  components: {
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      forRefresh: '',
      actionsArray: [],
      editedPayment: '',
      columns: [
        {
          label: 'Reference Number',
          field: 'referenceNumber',
        },
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Price',
          field: 'price',
        },
        {
          label: 'Payment Method',
          field: 'paymentMethod.name',
        },
        {
          label: 'File',
          field: 'file.url',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  watch: {
    forRefresh(val) {
      this.getPayments(this.$route.params.id)
    },
  },
  created() {
    this.getPayments(this.$route.params.id)
  },
  methods: {
    getPayments(id) {
      this.loading = true
      paymentService.index(id).then(response => {
        this.rows = response.data.data
        this.loading = false
      })
    },
    handleActions(itemObj) {
      console.log(itemObj)
      switch (itemObj.key) {
        case 'Payments':
          console.log('Payments Object *******>', itemObj)

          // this.$router.push({ name: 'representatives', params: { id: itemObj.id } })
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    getEditedObject(obj) {
      this.editedPayment = obj
      console.log('======>', this.editedPayment)
    },
    catchVar(e) {
      this.forRefresh = e
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      console.log('arr', arr.length)
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            paymentService.delete(this.$route.params.id, arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => Promise.reject(error))
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    renderTable() {
      this.getPayments(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
